import { fetchCabasEstimates, type CabasEstimateListResponse } from '@/services/cabas'
import type { CabasEstimateListQuery } from '@backend/schemas'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

export const useCabasEstimates = (params: Partial<CabasEstimateListQuery>) => {
  return useQuery<CabasEstimateListResponse>({
    queryKey: ['cabas-estimates', params],
    queryFn: () => fetchCabasEstimates(params),
    placeholderData: keepPreviousData,
  })
}
